<div [ngClass]="{ 'psg-style' : usePsgStyle, 'is-last': isLast }" class="vertical-progress-row flex-row flex-start">
  <ukg-divider direction="vertical" [ngClass]="extendToNextStep ? 'status-success' : 'disabled-color'"></ukg-divider>
  <div class="vertical-progress-stop-container">
    <ukg-icon *ngIf="!inProgress && !complete" name="badge-dot" class="disabled-color"></ukg-icon>
    <ukg-icon *ngIf="inProgress && !complete" name="badge-dot"></ukg-icon>
    <ukg-icon *ngIf="!inProgress && complete" name="status-finished" class="status-success"></ukg-icon>
    <ukg-icon *ngIf="inProgress && complete" name="status-finished" class="status-success"></ukg-icon>
  </div>
  <div class="flex-grow-full flex-fill">
    <ng-content></ng-content>
  </div>
</div>